export default __webpack_public_path__ + "static/media/DescriptionCard.6394f2bb.svg";